import React, { cloneElement } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'

const IconGroup = ({ className, childClassName, icons }) => {
  const renderedIcons = icons.map(({ anchor, component }) => {
    let renderedChild = (anchor && anchor.href)
      ? <a href={anchor.href} target={anchor.target || '_blank'} rel={anchor.rel || 'noopener noreferrer'}>{ component }</a>
      : component

    if (childClassName) {
      renderedChild = <div className={childClassName}>{ renderedChild }</div>
    }

    return cloneElement(renderedChild, { key: uuid() })
  })

  return (
    <div {...(className && { className })}>
      { renderedIcons }
    </div>
  )
}

IconGroup.propTypes = {
  className: PropTypes.string,
  childClassName: PropTypes.string,
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      anchorUrl: PropTypes.string,
      component: PropTypes.element
    })
  )
}

IconGroup.defaultProps = {
  className: undefined,
  childClassName: undefined,
  icons: []
}

export default IconGroup
